/* tslint:disable */

declare var Object: any;
export interface SFAttValidationInterface {
  "id"?: number;
}

export class SFAttValidation implements SFAttValidationInterface {
  "id": number;
  constructor(data?: SFAttValidationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttValidation`.
   */
  public static getModelName() {
    return "SFAttValidation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttValidation for dynamic purposes.
  **/
  public static factory(data: SFAttValidationInterface): SFAttValidation{
    return new SFAttValidation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttValidation',
      plural: 'SFAttValidations',
      path: 'SFAttValidations',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttValidation.ts